module.exports = __webpack_public_path__ + "static/media/screen-time-scheduling.3358cf89.svg";